import styled from "styled-components";
import { Paper } from "@mui/material";

export const HeroSection = styled.div`
  position: relative;
  height: 550px;
  width: 100%;
`;

export const HeroBackgroundImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FeatureSection = styled.div`
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
`;

export const HeroText = styled.div`
  position: absolute; /* Absolute positioning to overlay on the image */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Center the HeroText within HeroSection */
  z-index: 2; /* Ensure that the text and buttons are on top */
  color: #ffffff; /* Adjust the color as needed for visibility against the image */
  text-align: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.5); /* Optional: Adds a semi-transparent background to the text for readability */
`;

export const CallToActionRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const CallToActionBox = styled(Paper)`
  flex: 1;
  padding: 20px;
  margin: 0 10px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-10px);
  }

  @media (max-width: 768px) {
    margin: 10px 0;
    width: 90%; // Take up most of the screen width, but leave a little margin
  }
`;
